var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mine container",class:{ 'side-collapsed': _vm.sideCollapsed }},[_c('side',{staticClass:"side",on:{"collapse-change":_vm.onSideCollapse}}),_c('div',{staticClass:"rightMain"},[_c('keep-alive',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }